import React, { useEffect } from "react";
// import Link from "next/link";
// import Slider from "react-slick";
import { useSelector } from "react-redux";

// import officelistingStyle from "../../../styles/sass/office-listing.module.scss";
// import BannerImage from "../../../../public/assets/images/booking-request-bg.jpg";
// import dedicatedDesk from "../../../assets/images/img-dedicated-desk.jpg";
// import flexiDesk from "../../../assets/images/img-flexi-desk.jpg";
// import meetingRoom from "../../../assets/images/img-meeting-room.jpg";
// import arrowIcon from "../../../../public/assets/images/arrow-icon.svg";
/* import Tourform from "../../utils/Tourform";
import Enqiurybtn from "./Enqiurybtn"; */
// import { resourceTypes } from "../../../utils/CommonFunctions";
// import BannerContainer from "./components/BannerContainer";
// import Overview from "../../common-components/overview/Overview";
// import Faqs from "../../common-components/faqs/Faqs";
// import Testimonials from "../../common-components/testimonials/Testimonials";
// import {
//   overviewData,
//   faqsData,
//   testimonialData,
//   testimonialContentData,
//   blogData,
//   categoryData,
// } from "../../../other-object/ObjAccordion";
// import Blog from "../../common-components/blog/Blog";
// import CategorySlider from "../../common-components/categoryslider/CategorySlider";
import bannerImage from "../../../../public/assets/images/banner-img-top-2.jpg";
import BannerInner from "../../../components/common-components/bannerinner/BannerInner";
import constants from "../../../utils/Constants";

const { OFFICE_LIST_FOLDS } = constants;

/* const Officelisting = ({ tourForm, tourFormToggle }) => { */
const Officelisting = () => {
  const { cmsMap } = useSelector(({ cms }) => cms);

  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: false,
    autoplaySpeed: 4000,

    responsive: [
      {
        breakpoint: 9999,
        settings: "unslick",
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      <BannerInner title={"Office Spaces in Bermondsey, London"} imageSrc={bannerImage} />
      {/* <BannerContainer imageSrc={BannerImage.src}/> */}
      {/* <Overview orientation={"right"} data={overviewData} />
      <CategorySlider data={categoryData} />
      <Blog data={blogData} />
      <Testimonials
        bgColorValue={"f9f9f9"}
        data={testimonialData}
        testimonialContentData={testimonialContentData}
      />
      <Faqs data={faqsData} /> */}

      {OFFICE_LIST_FOLDS.map((fold) => {
        const { Component, _id } = fold;
        const mCMS = cmsMap[_id];

        if (mCMS?.active) {
          return <Component key={_id} data={mCMS} />;
        }
      })}

      {/* <div
        className={`${officelistingStyle.ol_o_cb} ${officelistingStyle.activeFormCon}`}
      >
        <div className={`${officelistingStyle.ol_i_cb} scroll_cb`}>
          <Slider {...settings} className={officelistingStyle.ol_o_g_cb}>
            {Object.values(resourceTypes).map(
              (resourceType, index) =>
                resourceType.active && (
                  <div className={officelistingStyle.ol_i_grid} key={index}>
                    <div className="set_loading_cb set_height_l_l_cb">
                      <div className="loader_cb">
                        <div className="loading_text_data">
                          Loading Image...
                        </div>
                        <div className="loading-spinner"></div>
                      </div>
                      <div
                        className={officelistingStyle.ol_img_con}
                        style={{
                          backgroundImage: `url(${resourceType?.bgImage})`,
                        }}
                      >
                        <img
                          className={officelistingStyle.full_img}
                          alt={resourceType?.name}
                          src={resourceType?.bgImage}
                          loading="lazy"
                        />

                        <Link href={`/office-spaces/${resourceType?._id}`}>
                          <a>
                            <h3 className={officelistingStyle.title}>
                              {resourceType?.name}
                            </h3>
                            <span>
                              View Details
                              <i>
                                <img src={arrowIcon.src} alt="arrow-icon" />
                              </i>
                            </span>
                          </a>
                        </Link>
                      </div>
                    </div>
                  </div>
                )
            )}
          </Slider>
        </div>
      </div> */}

      {/* <Tourform tourForm={tourForm} tourFormToggle={tourFormToggle} />
      <Enqiurybtn tourFormToggle={tourFormToggle} /> */}
    </>
  );
};
export default Officelisting;
